<template>
  <div class="column_center_start body"></div>
</template>

<script>
import auth from "@/utils/auth.utils";
import {
  CLAIM_OFFER_QUERY_KEY,
  CLAIM_LOGIN_QUERY_KEY,
  CLAIM_LOGIN_QUERY_VALUE,
  OPEN_PAGE_QUERY_KEY,
  getClaimOfferUuid,
  getOpenPage,
} from "@/utils/couponClaimLink.utils";
import commonUtils from "@/utils/common.utils";

// 依 state 的 store／data 組出導向路徑；store-list 為無 store code 的專用頁
const getStatePath = (stateData) => {
  if (stateData.page === "store-list") return "/store-list";
  let path = `/${stateData.store}`;
  if (stateData.data) {
    Object.keys(stateData.data).forEach((key) => {
      path += `/${stateData.data[key]}`;
    });
  }
  return path;
};

// LINE 回跳且已用停用自動登入重試過（state.login_retry）仍未取得 token，回傳原 state
const getFailedRetryState = (queryData) => {
  if (typeof queryData.code !== "string" || !queryData.code.trim()) return null;
  try {
    const stateData = JSON.parse(queryData.state);
    return stateData?.login_retry ? stateData : null;
  } catch (error) {
    return null;
  }
};

export default {
  computed: {
    isLogin() {
      return this.$store.getters["userData/isLogin"];
    },
  },
  data() {
    return {};
  },
  beforeMount() {
    this.redirect();
  },
  methods: {
    async redirect() {
      try {
        // 取得 query 參數
        const queryData = this.$route.query;
        console.log("query data", queryData);

        // 先檢查：如果沒有任何參數，重導向到官網（不管登入狀態）
        if (!queryData || Object.keys(queryData).length === 0) {
          console.log("no query data, redirect to external page");
          window.location.href = "https://www.okshop.tw/";
          return;
        }

        // 再檢查是否有 LINE 登入資料
        const lineLoginData = this.$store.state.line.lineLoginData;
        const accessToken = this.$store.getters["line/accessToken"];

        if (!lineLoginData || !accessToken) {
          // 重試仍失敗：導回原本要去的頁面（未登入，可再點登入），不停在空白首頁
          const failedRetryState = getFailedRetryState(queryData);
          if (failedRetryState) {
            commonUtils.createToast("error", "LINE 登入失敗，請再試一次");
            if (
              failedRetryState.store ||
              failedRetryState.page === "store-list"
            ) {
              this.$router.push({ path: getStatePath(failedRetryState) });
            }
            return;
          }
          console.log("no access token, stay at home page");
          return;
        } else {
          // 有登入資料，處理 state 參數重導向
          let stateData = {};
          if (queryData.state) {
            stateData = { ...JSON.parse(queryData.state) };
            console.log("queryData contains stateData", stateData);
          }
          // /store-list 專用導向（無 store code）
          if (stateData.page === "store-list") {
            this.$router.push({ path: getStatePath(stateData) });
            return;
          }
          const claimOffer = getClaimOfferUuid(stateData.claim_offer);
          if (claimOffer && stateData.store && !stateData.data) {
            const isClaimLoginReturn =
              typeof queryData.code === "string" &&
              Boolean(queryData.code.trim());
            this.$router.push({
              path: `/${stateData.store}`,
              query: {
                [CLAIM_OFFER_QUERY_KEY]: claimOffer,
                ...(isClaimLoginReturn
                  ? { [CLAIM_LOGIN_QUERY_KEY]: CLAIM_LOGIN_QUERY_VALUE }
                  : {}),
              },
            });
            return;
          }
          // 推播連結：回 VIP 卡完成 OKPOS 登入後再開啟指定頁面
          const openPage = getOpenPage(stateData.open);
          if (openPage && stateData.store && !stateData.data) {
            this.$router.push({
              path: `/${stateData.store}`,
              query: { [OPEN_PAGE_QUERY_KEY]: openPage },
            });
            return;
          }
          this.$router.push({ path: getStatePath(stateData) });
        }
      } catch (error) {
        // 發生錯誤時重導向到官網
        console.error("redirect error", error);
        auth.logout();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.body {
  background-color: #eeeeee;
  height: 100vh;
  width: 100vw;

  button {
    margin-top: 10px;
  }
}
</style>
